import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined'
import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { ReactComponent as VacationIcon } from 'assets/services/hold/VacationIcon.svg'
import { ReactComponent as HoldIcon } from 'assets/work-orders/HoldIcon.svg'
import { ReactComponent as MixedStatusIcon } from 'assets/work-orders/MixedStatusIcon.svg'
import { WORK_ORDER_STATUS } from 'settings/constants/service'

import type { SxProps, Theme } from '@mui/material/styles'

const { SERVICED, SKIPPED, IN_PROCESS, SCHEDULED, CANCELED, HOLD, SUSPENDED, MIXED, PARTIALLY_SERVICED, PARTIALLY_SKIPPED, VACATION_HOLD } =
  WORK_ORDER_STATUS

/**
 * Shared by WorkOrderStatusChip and WorkOrderStatusBadge so the two can't drift. Returns null for a
 * status with no glyph of its own — Partial and Complete today. Both callers used to seed the
 * Scheduled calendar and override on match, which rendered every unmapped status as Scheduled.
 */
export const hasSplitStatusIcon = (status?: string): boolean => status === PARTIALLY_SERVICED || status === PARTIALLY_SKIPPED

export const getWorkOrderStatusIcon = (status: string | undefined, sx: SxProps<Theme>): React.ReactNode | null => {
  if (!status) return null
  if (status === SCHEDULED) return <CalendarTodayOutlinedIcon sx={sx} />
  if (status === CANCELED) return <CloseIcon sx={sx} />
  // The partial roll-ups share mobile's split badge: its own green/red, not the chip's glyph colour.
  if (status === PARTIALLY_SERVICED || status === PARTIALLY_SKIPPED) {
    return (
      <SvgIcon inheritViewBox sx={sx}>
        <MixedStatusIcon />
      </SvgIcon>
    )
  }
  if (status === SERVICED) return <CheckIcon sx={sx} />
  if (status === SKIPPED) return <FastForwardOutlinedIcon sx={sx} />
  if (status === IN_PROCESS) return <PlayCircleOutlineOutlinedIcon sx={sx} />
  if (status === SUSPENDED) return <DeleteOutlineIcon sx={sx} />
  if (status === MIXED) return <MoreHorizIcon sx={sx} />
  if (status === VACATION_HOLD) {
    return (
      <SvgIcon inheritViewBox sx={sx} viewBox="0 0 12 14">
        <VacationIcon />
      </SvgIcon>
    )
  }
  if (status === HOLD) {
    return (
      <SvgIcon inheritViewBox sx={sx} viewBox="0 0 12 10">
        <HoldIcon />
      </SvgIcon>
    )
  }
  return null
}
